import Vue from "vue";
import Router from "vue-router";
import ChatStudioView from "../views/ChatStudioView.vue";
import CourseDetailView from "../views/CourseDetailView.vue";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import PlazaView from "../views/PlazaView.vue";
import RegisterView from "../views/RegisterView.vue";
import { readAuthState } from "../utils/auth";

Vue.use(Router);

var router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: {
        guestOnly: true
      }
    },
    {
      path: "/register",
      name: "register",
      component: RegisterView,
      meta: {
        guestOnly: true
      }
    },
    {
      path: "/",
      name: "home",
      component: HomeView,
      beforeEnter: function(to, from, next) {
        var auth = readAuthState();

        if (!auth.accessToken) {
          next({
            name: "login"
          });
          return;
        }

        next();
      },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/courses/:id",
      name: "course-detail",
      component: CourseDetailView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/plaza",
      name: "plaza",
      component: PlazaView,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/chat/text/:id?",
      name: "chat-text",
      component: ChatStudioView,
      meta: {
        requiresAuth: true,
        type: "text"
      }
    },
    {
      path: "/chat/picture/:id?",
      name: "chat-picture",
      component: ChatStudioView,
      meta: {
        requiresAuth: true,
        type: "picture"
      }
    },
    {
      path: "/chat/video/:id?",
      name: "chat-video",
      component: ChatStudioView,
      meta: {
        requiresAuth: true,
        type: "video"
      }
    },
    {
      path: "/chat/speech/:id?",
      name: "chat-speech",
      redirect: {
        name: "chat-text"
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach(function(to, from, next) {
  var auth = readAuthState();
  var hasToken = !!auth.accessToken;

  if (to.matched.some(function(record) { return record.meta.requiresAuth; }) && !hasToken) {
    next({
      name: "login"
    });
    return;
  }

  if (to.matched.some(function(record) { return record.meta.guestOnly; }) && hasToken) {
    next({
      name: "home"
    });
    return;
  }

  next();
});

export default router;
